import { Form, Formik, FormikHelpers } from "formik";
import { array, object, string } from "yup";
import { ProductFormValues } from "src/models/Product.model";
import ProductForm from "../Layouts/ProductForm";
import { useAddProductMutation } from "src/services/ProductService";
import { showToast } from "src/utils/showToaster";
import { useNavigate } from "react-router-dom";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";

export const formatValueInFlatOrPercent = (
  value: any,
  type: "FLAT" | "PERCENT"
) => {
  return type === "PERCENT" ? `${value}%` : `${value}`;
};
const AddProductWrapper = () => {
  const navigate = useNavigate();
  // Form Initial Values
  const initialValues: ProductFormValues = {
    productName: "",
    instituteName: [],
    nickname: "",
    productMrp: "0",
    maxDiscount: "0",
    maxDiscountType: { label: "Flat", value: "FLAT" },
    walletDiscount: "0",
    walletDiscountType: { label: "Flat", value: "FLAT" },
    referralToPercentage: "0",
    referralToPercentageType: { label: "Flat", value: "FLAT" },
    courierCharges: [],
    referralByPercentage: "0",
    referralByPercentageType: { label: "Flat", value: "FLAT" },
    varientCode: "",
    code: "",

    subject: [],

    faculty: [],

    courseName: "",
    batchType: "",
    levelName: "",
    categoryName: "",
    groupName: "",
    modeName: "",
    moduleName: "",
    syllabusName: "",

    searchKeyCode: "",
    image: [],
    gdLink: "",
    demoLinks: "",
    demoName: "",
    viewDemo: "",
    demoLinkIsAvailable: { label: "Yes", value: "YES" },

    contactTechnicalSupport: "",
    contactTrackingSupport: "",

    additionalRequirement: "",
    rank: "",
    detailsAmendments: "",
    whyToBuy: "",
    contactForDoubtSolving: "",
    impDescription: "",
    shippingMethod: "",

    meta: "",
    metaTitle: "",
    imageAltText: "",

    allowedPaymentGateway: "",

    rating: "",
    remark: "",
    documentToBeProvidedForOrderProcessing: "",
    orderGoogleSheetLink: "",
    validityExplanationVidUrl: "",
    productExplanationVideoUrl: "",
    viewExplanationVidUrl: "",
    index: "",
    additionalDescription: "",
    tinyUrl: "",

    unboxingVidLinks: [],
    relevantProducts: [],
    studentAlsoPurchased: [],

    isCombo: { label: "No", value: "NO" },
    isAvailable: { label: "Yes", value: "YES" },
    isHidden: { label: "No", value: "NO" },
    importantNotice: "",
    isActive: { label: "Yes", value: "YES" },
    inOffer: { label: "No", value: "NO" },
    noOfViews: "",
    viewCountAs: "",
    viewExtension: "",
    validity: "",
    validityStartsFrom: "",
    validityExtension: "",
    topicsCovered: "",
    multipleDemo: "",
    processingTime: "",
    productNotes: "",
    additionalOffer: "",
    language: "",
    noOfLectures: "",
    duration: "",
    studyMaterial: "",
    attempts: "",
    batchRecording: "",
    kitContent: "",
    lectureRecordingDate: "",
    videoRunsOn: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    productName: string().required("Please enter product name"),
    instituteName: array()
      .of(object())
      .min(1, "Please select a institute")
      .required("Please select a institute"),
    code: string().required("Please enter product code"),
    varientCode: string().required("Please enter varient code"),
    nickname: string().required("Please enter nick name"),
    courseName: object().required("Please select course"),
    levelName: object().required("Please select level name"),
    batchType: object().required("Please select Batch Type"),
    subject: array()
      .of(object())
      .min(1, "Please select a subject")
      .required("Please select a subject"),
    // courierCharges: array()
    //   .of(object())
    //   .min(1, "Please select a subject")
    //   .required("Please select a subject"),
    faculty: array()
      .of(object())
      .min(1, "Please select a faculty")
      .required("Please select a faculty"),
    moduleName: object().required("Please select module"),
    groupName: object().required("Please select group"),
    syllabusName: object().required("Please select syllabus name"),
    rank: string().required("Please enter rank"),
    modeName: object().required("Please select mode name"),
    categoryName: object().required("Please select category name"),
    productMrp: string().required("please enter product MRP"),
    maxDiscount: string()
      .test(
        "test-referral-to-percentage",
        "Must be between 0 and 100",
        (value = "0", context) => {
          if (context.parent?.maxDiscountType.value === "PERCENT") {
            if (Number(value) > 100 || Number(value) < 0) {
              return context.createError({
                message: "Cannot be greater than 100%",
                path: context.path,
              });
            }
            return true;
          }
          return true;
        }
      )
      .required("Please enter Value"),
    walletDiscount: string()
      .test(
        "test-referral-to-percentage",
        "Must be between 0 and 100",
        (value = "0", context) => {
          if (context.parent?.walletDiscountType.value === "PERCENT") {
            if (Number(value) > 100 || Number(value) < 0) {
              return context.createError({
                message: "Cannot be greater than 100%",
                path: context.path,
              });
            }
            return true;
          }
          return true;
        }
      )
      .required("Please enter Value"),
    referralToPercentage: string()
      .test(
        "test-referral-to-percentage",
        "Must be between 0 and 100",
        (value = "0", context) => {
          if (context.parent?.referralToPercentageType.value === "PERCENT") {
            if (Number(value) > 100 || Number(value) < 0) {
              return context.createError({
                message: "Cannot be greater than 100%",
                path: context.path,
              });
            }
            return true;
          }
          return true;
        }
      )
      .required("Please enter Value"),
    referralByPercentage: string()
      .test(
        "test-referral-to-percentage",
        "Must be between 0 and 100",
        (value = "0", context) => {
          if (context.parent?.referralByPercentageType.value === "PERCENT") {
            if (Number(value) > 100 || Number(value) < 0) {
              return context.createError({
                message: "Cannot be greater than 100%",
                path: context.path,
              });
            }
            return true;
          }
          return true;
        }
      )
      .required("Please enter Value"),
    demoLinkIsAvailable: object().required(
      "Please select if demo link is available"
    ),
    isHidden: object().required("Please select hidden option"),
    searchKeyCode: string().required("Please enter search key code"),
    gdLink: string()
      .url("Please enter a valid Google Drive link")
      .required("Please enter GD Link"),
    demoLinks: string()
      .url("Please enter a valid demo link")
      .required("Please enter demo link"),
    demoName: string().required("Please enter demo name"),
    viewDemo: string().url("Please enter a valid view demo link"),
    contactTechnicalSupport: string()
      .matches(/^[0-9]+$/, "Only numbers allowed")
      .min(10, "Must be at least 10 digits")
      .required("Please enter contact technical support"),
    contactTrackingSupport: string()
      .matches(/^[0-9]+$/, "Only numbers allowed")
      .min(10, "Must be at least 10 digits")
      .required("Please enter contact tracking support"),
    additionalRequirement: string(),
    detailsAmendments: string(),
    whyToBuy: string(),
    contactForDoubtSolving: string()
      .matches(/^[0-9]+$/, "Only numbers allowed")
      .min(10, "Must be at least 10 digits"),
    shippingMethod: string().required("Please enter shipping method"),
    meta: string().required("Please enter meta"),
    metaTitle: string().required("Please enter meta title"),
    imageAltText: string().required("Please enter image alt text"),

    rating: string()
      .typeError("Rating must be a number")
      .min(0, "Rating must be at least 0")
      .max(5, "Rating cannot exceed 5"),
    documentToBeProvidedForOrderProcessing: string(),
    orderGoogleSheetLink: string()
      .url("Please enter a valid Google Sheet link")
      .required("Please enter order Google Sheet link"),
    validityExplanationVidUrl: string()
      .url("Please enter a valid video URL")
      .required("Please enter validity explanation video url"),
    productExplanationVideoUrl: string()
      .url("Please enter a valid video URL")
      .required("Please enter product explanation video url"),
    viewExplanationVidUrl: string()
      .url("Please enter a valid video URL")
      .required("Please enter view explanation video url"),
    index: string().required("Please enter index"),
    tinyUrl: string().url("Please enter a valid tiny url"),
    relevantProducts: array().of(object()),
    // .min(1, "Please select at least one relevant product"),
    studentAlsoPurchased: array().of(object()),
    // .min(1, "Please select at least one product"),
    additionalDescription: string().required(
      "Please enter additional description"
    ),
    unboxingVidLinks: array()
      .of(string().url("Invalid video link"))
      .min(1, "Please add at least one unboxing video link"),
    image: array(),
    // .of(string().required("Image is required")),
    // .min(1, "Please upload at least one image"),
    remark: string().nullable(),
    importantNotice: string(),
  });
  const [addProduct] = useAddProductMutation();

  // Handle Submit
  const handleSubmit = (
    values: ProductFormValues,
    { setSubmitting, resetForm }: FormikHelpers<ProductFormValues>
  ) => {

    const formattedValues = {
      productName: values.productName,
      nickname: values.nickname,
      productMrp: Number(values.productMrp),

      maxDiscount: formatValueInFlatOrPercent(
        values?.maxDiscount,
        values?.maxDiscountType?.value
      ),
      walletDiscount: formatValueInFlatOrPercent(
        values?.walletDiscount,
        values?.walletDiscountType?.value
      ),
      referralToPercentage: formatValueInFlatOrPercent(
        values?.referralToPercentage,
        values?.referralToPercentageType?.value
      ),
      referralByPercentage: formatValueInFlatOrPercent(
        values?.referralByPercentage,
        values?.referralByPercentageType?.value
      ),

      courierCharges: values.courierCharges
        ?.map((c: any) => `${c.day} day: ${c.charge}`)
        .join(", "),

      varientCode: values.varientCode,
      code: values.code,

      subject: values.subject?.map((s: any) => s.label).join(","),
      faculty: values.faculty?.map((f: any) => f.label).join(","),
      institute: values.instituteName?.map((f: any) => f.label).join(","),
      courseName: values.courseName?.label,
      batchType: values.batchType?.label,
      levelName: values.levelName?.label,
      categoryName: values.categoryName?.label,
      groupName: values.groupName?.label,
      modeName: values.modeName?.label,
      moduleName: values.moduleName?.label,
      syllabusName: values.syllabusName?.label,

      searchKeyCode: values.searchKeyCode,

      image: values.image?.map((img: any) => img).join(","),

      gdLink: values.gdLink,
      demoLinks: values.demoLinks,
      demoName: values.demoName,
      viewDemo: values.viewDemo,
      demoLinkIsAvailable: values.demoLinkIsAvailable?.value,

      isCombo: values.isCombo?.value,
      isAvailable: values.isAvailable?.value,
      isHidden: values.isHidden?.value,

      contactTechnicalSupport: values.contactTechnicalSupport,
      contactTrackingSupport: values.contactTrackingSupport,
      additionalRequirement: values.additionalRequirement,
      rank: values.rank,
      detailsAmendments: values.detailsAmendments,
      whyToBuy: values.whyToBuy,
      contactForDoubtSolving: values.contactForDoubtSolving,
      impDescription: values.impDescription,
      shippingMethod: values.shippingMethod,
      meta: values.meta,
      metaTitle: values.metaTitle,
      imageAltText: values.imageAltText,
      rating: Number(values.rating),

      remark: values.remark,
      productUrlSlug: "",
      documentToBeProvidedForOrderProcessing:
        values.documentToBeProvidedForOrderProcessing,
      orderGoogleSheetLink: values.orderGoogleSheetLink,
      validityExplanationVidUrl: values.validityExplanationVidUrl,
      productExplanationVideoUrl: values.productExplanationVideoUrl,
      viewExplanationVidUrl: values.viewExplanationVidUrl,
      index: values.index,
      additionalDescription: values.additionalDescription,
      tinyUrl: values.tinyUrl,

      unboxingVidLinks: values.unboxingVidLinks?.join(","),
      relevantProducts: values.relevantProducts
        ?.map((p: any) => p.value)
        .join(","),
      studentAlsoPurchased: values.studentAlsoPurchased
        ?.map((p: any) => p.value)
        .join(","),

      allowedPaymentGateway: values.allowedPaymentGateway
        ?.map((p: any) => p.value)
        .join(","),
      importantNotice: values.importantNotice,
      isActive: values.isActive?.value,
      inOffer: values.inOffer.value,
      noOfViews: values.noOfViews,
      viewCountAs: values.viewCountAs,
      viewExtension: values.viewExtension,
      validity: values.validity,
      validityStartsFrom: values.validityStartsFrom,
      validityExtension: values.validityExtension,
      topicsCovered: values.topicsCovered,
      multipleDemo: values.multipleDemo,
      processingTime: values.processingTime,
      productNotes: values.productNotes,
      additionalOffer: values.additionalOffer,
      language: values.language,
      noOfLectures: values.noOfLectures,
      duration: values.duration,
      studyMaterial: values.studyMaterial,
      attempts: values?.attempts,
      batchRecording: values?.batchRecording,
      kitContent: values?.kitContent,
      lectureRecordingDate: values?.lectureRecordingDate,
      videoRunsOn: values?.videoRunsOn,
    };

    addProduct(formattedValues).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          navigate("/products");
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <SideNavLayout>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <ProductForm formikProps={formikProps} formType="ADD" />
          </Form>
        )}
      </Formik>
    </SideNavLayout>
  );
};

export default AddProductWrapper;
